import React from 'react';
import pt from 'prop-types';
import { noop } from 'lodash';
import { BaseDialog } from '@metarouter-private/mr-mui';

import useOrgSwitcher from './useOrgSwitcher';
import OrgSwitcherContent from './OrgSwitcherContent';

const DIALOG_PROPS = { open: true, maxWidth: 'xs', fullWidth: true, 'data-test-id': 'OrgSwitcherDialog' };

export default function OrgSwitcher({ orgId, closeModal }) {
  const orgSwitcher = useOrgSwitcher({ orgId });

  return (
    <BaseDialog
      DialogProps={{ ...DIALOG_PROPS, onClose: orgSwitcher.switching ? noop : closeModal }}
      title="Switch Organization"
      content={<OrgSwitcherContent {...orgSwitcher} onSelectCurrent={closeModal} />}
    />
  );
}

OrgSwitcher.propTypes = {
  orgId: pt.string,
  closeModal: pt.func,
};
